import React, { Component } from 'react';
import Button from '../../forms/Button';
import SelectEventMenu from './SelectEventMenu';
import ApplicationMenuWrapper from './ApplicationMenuWrapper';
import { Link } from 'react-router-dom';
import {
  CHANGE_PASSWORD_PATH,
  CONTRACTS_PATH,
  ADMIN_ROOT_PATH,
  TWO_FACTOR_RECOVERY_PATH
} from '../../../constants/routes';
import { withScrollDisable } from '../../hocs/scroll';
import { ifPermission, PERMISSIONS, hasPermissions } from '../../../constants/authentication/permissions';

class ApplicationMenu extends Component {
  componentDidMount() {
    this._fetchEvents();
  }
  componentDidUpdate() {
    this._fetchEvents();
  }
  _fetchEvents = () => {
    this.props.user && hasPermissions(this.props.user, PERMISSIONS.VIEW_LINEUP) && this.props.fetchEvents();
  };
  render() {
    return (
      <ApplicationMenuWrapper open={this.props.open} closeMenu={this.props.closeMenu}>
        {ifPermission(
          this.props.user,
          PERMISSIONS.VIEW_LINEUP,
          <SelectEventMenu
            onClick={this.props.selectOpenMenu}
            events={this.props.events}
            selected={this.props.selectedEvent}
            open={this.props.selectIsOpen}
            closeMenu={this.props.selectCloseMenu}
            selectedId={this.props.selectedId}
          />
        )}
        <span className="ckp-modal-full-line" />
        <div className="ckp-application-menu-email ckp-ts-h4">{this.props.userEmail}</div>
        <span className="ckp-modal-full-line" />
        {ifPermission(
          this.props.user,
          PERMISSIONS.ACCESS_ADMIN,
          <React.Fragment>
            <Link to={ADMIN_ROOT_PATH} className="ckp-application-menu-link ckp-ts-h3">
              Admin
            </Link>
            <span className="ckp-modal-full-line is-sub" />
          </React.Fragment>
        )}
        {hasPermissions(this.props.user, PERMISSIONS.VIEW_CONTRACTS_INBOX) ||
        hasPermissions(this.props.user, PERMISSIONS.VIEW_SIGNED_CONTRACTS_INBOX) ? (
          <React.Fragment>
            <Link to={CONTRACTS_PATH} className="ckp-application-menu-link ckp-ts-h3">
              Contracts
            </Link>
            <span className="ckp-modal-full-line is-sub" />
          </React.Fragment>
        ) : null}
        <Link to={CHANGE_PASSWORD_PATH} className="ckp-application-menu-link ckp-ts-h3">
          Change password
        </Link>
        <span className="ckp-modal-full-line is-sub" />
        {ifPermission(
          this.props.user,
          PERMISSIONS.ACCESS_ADMIN,
          <React.Fragment>
            <Link to={TWO_FACTOR_RECOVERY_PATH} className="ckp-application-menu-link ckp-ts-h3">
              Two-Factor Authentication
            </Link>
            <span className="ckp-modal-full-line is-sub" />
          </React.Fragment>
        )}
        <Button
          className="ckp-application-menu-sign-out is-red"
          onClick={this.props.logOut}
          inactive={false}
          label="Sign out"
        />
      </ApplicationMenuWrapper>
    );
  }
}

export default withScrollDisable(ApplicationMenu);
